/**
 * Theme Requirements Aggregation for Repli Sandbox Avenew
 * 
 * Extends the base avenue theme requirements with Repli Sandbox Avenew specific
 * component requirements.
 */

import type { ComponentRequirements } from '@vibesites/tokens';
import { componentRequirements as baseRequirements } from '@vibesites/theme-avenue/requirements';

/**
 * Repli Sandbox Avenew component requirement overrides.
 * Add requirements for any override components here.
 */
const replisandboxavenewOverrides: Record<string, ComponentRequirements> = {
  // Example:
  // Footer: FooterRequirements,
};

/**
 * All component requirements for the Repli Sandbox Avenew theme.
 * Inherits from avenue theme and overrides with Repli Sandbox Avenew components.
 */
export const componentRequirements: Record<string, ComponentRequirements> = {
  ...baseRequirements,
  ...replisandboxavenewOverrides,
};

/**
 * Get requirements for a specific component.
 */
export function getComponentRequirements(componentName: string): ComponentRequirements | undefined {
  return componentRequirements[componentName];
}

/**
 * Get all component names that have requirements defined.
 */
export function getRegisteredComponentNames(): string[] {
  return Object.keys(componentRequirements);
}
